import React from 'react';
import { Button, Flex, FlexProps } from '@mantine/core';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { DragAndDrop } from '@dealstack/frontend/shared/components/DragAndDrop/DragAndDrop';
import { useSignatureUploader } from '@dealstack/frontend/shared/components/Signature/SignatureUploader/useSignatureUploader';
import { PngPreview } from '@dealstack/frontend/shared/components/Signature/PngPreview/PngPreview';

interface Props extends FlexProps {
	controller: ReturnType<typeof useSignatureUploader>;
}

export const SignatureUploader = ({ controller, ...flexProps }: Props) => {
	const tCommonUi = useTranslationCommonUi();

	const { onImageChange, imageUrl } = controller;

	return (
		<Flex gap="1rem" direction="column" {...flexProps}>
			<Button
				variant="link-color"
				sx={{ alignSelf: 'flex-end' }}
				onClick={() => {
					void onImageChange(null);
				}}
				disabled={!imageUrl}
			>
				{tCommonUi('signature_upload.clear_signature', {
					defaultValue: 'Clear signature',
				})}
			</Button>

			{imageUrl ? (
				<PngPreview imageUrl={imageUrl} style={{ height: '13rem' }} />
			) : (
				<DragAndDrop
					onDrop={(files) => {
						void onImageChange(files[0]);
					}}
					accept={{
						'image/png': ['.png'],
						'image/jpeg': ['.jpg', '.jpeg'],
					}}
					invalidTypeMessage={tCommonUi('invalid_file_type')}
					style={{ height: '9rem' }}
					multiple={false}
				/>
			)}
		</Flex>
	);
};
